var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMovie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 512 512",
    id: "Layer_1",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_1_",
    x1: -0.0000027,
    x2: 512,
    y1: 256,
    y2: 256
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA05"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FAAC18"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "url(#SVGID_1_)",
    r: 256
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_2_",
    x1: 42.6666641,
    x2: 469.3333435,
    y1: 256.0005188,
    y2: 256.0005188
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FAAC18"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCA05"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256,469.3338623c-117.6314697,0-213.3333435-95.7018738-213.3333435-213.3333435    c0-117.6309204,95.7018661-213.333313,213.3333435-213.333313c117.6357422,0,213.3333435,95.7024002,213.3333435,213.333313    C469.3333435,373.6319885,373.6357422,469.3338623,256,469.3338623z",
    fill: "url(#SVGID_2_)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M368.9978638,144.0021362H159.0016022c-8.2842712,0-15,6.7151947-15,15v209.9962769   c0,8.2832031,6.7157288,15,15,15h209.9962616c8.2842712,0,15-6.7167969,15-15V159.0021362   C383.9978638,150.7173309,377.282135,144.0021362,368.9978638,144.0021362z M204.7615967,320.5823975v-113.165863L321.2373352,264   L204.7615967,320.5823975z",
    opacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M360.9978638,136.0021362H151.0016022c-8.2842712,0-15,6.7151947-15,15v209.9962769   c0,8.2832031,6.7157288,15,15,15h209.9962616c8.2842712,0,15-6.7167969,15-15V151.0021362   C375.9978638,142.7173309,369.282135,136.0021362,360.9978638,136.0021362z M196.7615967,312.5823975v-113.165863L313.2373352,256   L196.7615967,312.5823975z",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovie);
export default __webpack_public_path__ + "static/media/movie.68e81a156310e2a61501ab96ff75bb8f.svg";
export { ForwardRef as ReactComponent };